import React, { useEffect, useMemo, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { Popup } from "@progress/kendo-react-popup";
import { updateCurrUser } from "../../../../actions/auth";
import { getTasks } from "../../../../components/Tasks/tasks.service";
import { label, number, route } from "../../../../config";
import { onBlur, onFocus, onOpen } from "../../../../utils/kendo";
import { isNewStreamAdded } from "../../../services/projects.service";
import "./organisationPopUp.scss";
import { ORGANISATION_APP_IDS, getMyResourcesViews, getOrganisationApps } from "./organisationPopUpConstants";

const OrganisationPopUp = ({ setShowPopup, showPopup, handleShowDescription }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const auth = useSelector((state) => state.auth);
  const { organizationFeatureStatus } = useSelector((state) => state.company);
  const deleteRef = useRef(null);
  const blurTimeoutRef = useRef(null);

  const showDirectory = useMemo(
    () => organizationFeatureStatus?.find((feature) => feature?.FeatureId === number.TWELVE),
    [organizationFeatureStatus]
  );

  const organisationApps = useMemo(() => getOrganisationApps(!!showDirectory?.IsActive), [showDirectory?.IsActive]);

  useEffect(() => {
    (async () => {
      const unreadStreamId = await isNewStreamAdded(auth.user.id, null);
      dispatch(updateCurrUser({ isStreamUpdate: unreadStreamId.StreamAdded }));
    })();
  }, [auth.user.id]);

  const closePopup = () => {
    setShowPopup(false);
  };

  const navigateMyBoardView = async (boardLabel) => {
    closePopup();
    if (boardLabel === label.EMAILS) {
      history.push(route.PRIVATE_ROUTE.EMAILS.PATH);
      return;
    }
    if (boardLabel === label.AUTOMATIONS) {
      history.push("/userProfileRoute?IsAutomation=true");
      return;
    }
    if (boardLabel === label.WORKFLOWS) {
      history.push("/userProfileRoute?IsWorkflow=true");
      return;
    }
    if (boardLabel === label.CHIPS) {
      history.push("/userProfileRoute?IsChips=true");
      return;
    }
    if (boardLabel === label.FORMS) {
      history.push("/userProfileRoute?IsForm=true");
      return;
    }
    history.push(route.PRIVATE_ROUTE.TASKS.PATH);
    await dispatch(updateCurrUser({ lastSelectedBoard: boardLabel }));
  };

  const handleDirectoryClick = async () => {
    history.push(route.PRIVATE_ROUTE.USER_DIRECTORY.PATH);
    await dispatch(updateCurrUser({ lastSelectedBoard: label.BOARD_DIRECTORY }));
    closePopup();
  };

  const handleAppClick = (appId) => {
    switch (appId) {
      case ORGANISATION_APP_IDS.COLLAB_CENTRAL:
        handleShowDescription?.();
        break;
      case ORGANISATION_APP_IDS.DIRECTORY:
        void handleDirectoryClick();
        break;
      case ORGANISATION_APP_IDS.STREAMS:
        void navigateMyBoardView(label.STREAM);
        break;
      case ORGANISATION_APP_IDS.FORMS:
        void navigateMyBoardView(label.FORMS);
        break;
      case ORGANISATION_APP_IDS.AUTOMATIONS:
        void navigateMyBoardView(label.AUTOMATIONS);
        break;
      case ORGANISATION_APP_IDS.EMAILS:
        void navigateMyBoardView(label.EMAILS);
        break;
      case ORGANISATION_APP_IDS.MY_CANVAS:
        void navigateMyBoardView(label.MY_CANVAS);
        break;
      case ORGANISATION_APP_IDS.WORKFLOWS:
        void navigateMyBoardView(label.WORKFLOWS);
        break;
      case ORGANISATION_APP_IDS.CHIPS:
        void navigateMyBoardView(label.CHIPS);
        break;
      default:
        break;
    }
  };

  return (
    <div>
      <Popup
        popupClass='dt-popup organisation-popup-editor position-relative border-0'
        show={showPopup}
        animate={false}
        collision={{
          horizontal: "fit",
          vertical: "flip",
        }}
        onOpen={() => onOpen(deleteRef)}>
        <div tabIndex={number.ZERO} ref={deleteRef} onFocus={() => onFocus(blurTimeoutRef)} onBlur={() => onBlur(blurTimeoutRef, closePopup)}>
          <div className='popup-container'>
            <div className='section'>
              <label>Apps</label>
              <div className='icons'>
                {organisationApps.map(({ id, text, icon: appIcon, showStreamBadge }) => (
                  <div key={id} className='icon-item position-relative' onClick={() => handleAppClick(id)}>
                    <span className='icon'>{appIcon}</span>
                    <span className='text'>{text}</span>
                    {!!showStreamBadge && !!auth.user.isStreamUpdate && (
                      <span className='red-dot badge-red-dot position-absolute header-organisation-popup-reddot-inside rounded-circle ml-2' />
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </Popup>
    </div>
  );
};

export default OrganisationPopUp;
